export class WavyText {
    private readonly svg: SVGSVGElement;
    private readonly text: SVGTextElement;
    private readonly path: SVGPathElement;
    private readonly textPath: SVGTextPathElement;
    private trigger: any;
    private lastProgress: number = -1;

    constructor(private element: HTMLElement) {
        this.svg = this.element.querySelector('svg') as SVGSVGElement;
        this.text = this.svg?.querySelector('text') as SVGTextElement;
        this.path = this.svg?.querySelector('path') as SVGPathElement;
        this.textPath = this.text?.querySelector('textPath') as SVGTextPathElement;

        if (!this.svg || !this.text || !this.path || !this.textPath) {
            return;
        }

        this.init();
    }

    private init() {
        this.createTrigger();
    }

    private createTrigger(): void {
        this.trigger = window.scrollTrigger.create({
            trigger: this.element,
            start: 'top bottom',
            end: 'bottom top',
            scrub: true,
            fastScrollEnd: true,
            markers: false,
            onUpdate: (self) => this.updateProgress(self.progress),
        });

        if (this.trigger.progress > 0) {
            this.updateProgress(this.trigger.progress);
        }
    }

    private updateProgress(value: number): void {
        const clampedValue = Math.round(value * 100000) / 100000;

        if (Math.abs(this.lastProgress - clampedValue) > 0.00001) {
            this.lastProgress = clampedValue;
            this.textPath.setAttribute('startOffset', `-${50 - (clampedValue * 50)}%`);
        }
    }

    destroy(): void {
        this.trigger?.kill();
    }
}
